import { parseEmoji } from '@/helper/utils';
import { Project } from '@/types/project.types';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ProjectCard from './ProjectCard';

export const AllProjects = ({
  projectsData,
  loadMore,
  totalPages,
  loadedCount,
  loadLess,
  limit,
  currentPage,
  total,
  canLoadMore = false,
  canLoadLess = false,
}: {
  projectsData: Project[];
  totalPages: number;
  loadedCount: number;
  limit: number;
  currentPage: number;
  loadMore: () => void;
  loadLess: () => void;
  total: number;
  canLoadMore?: boolean;
  canLoadLess?: boolean;
}) => {
  const navigate = useNavigate();

  const remainingCount = Math.max(total - loadedCount, 0);

  if (!projectsData || projectsData.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-[65vh] text-gray-500 text-lg font-medium">
        No Projects Found
      </div>
    );
  }
  return (
    <div className="space-y-6 transition-all duration-300 ">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {projectsData?.map((project: any) => (
          <ProjectCard
            key={project.id}
            action={project}
            getEmoji={parseEmoji}
            navigate={navigate}
          />
        ))}

        {canLoadMore && remainingCount > 0 && (
          <button
            className="relative flex flex-col justify-between bg-[#AFAFAF] text-[#2B1C25] rounded-lg shadow hover:bg-[#9e8895] transition-all p-5 w-full"
            onClick={loadMore}
          >
            <div className="flex flex-col items-start">
              <span className="text-2xl font-bold">See More</span>
              <span className="text-sm">
                {remainingCount} project
                {remainingCount > 1 ? 's' : ''} remaining
              </span>
            </div>

            <ArrowDown
              className="absolute bottom-4 right-4 bg-transparent cursor-pointer p-1 rounded text-[#2B1C25]"
              height={44}
              width={44}
            />
          </button>
        )}

        {canLoadLess && (
          <button
            className="relative flex flex-col justify-between bg-[#AFAFAF] text-[#2B1C25] rounded-lg shadow hover:bg-[#9e8895] transition-all p-5 w-full"
            onClick={loadLess}
          >
            <div className="flex flex-col items-start">
              <span className="text-2xl font-bold">See Less</span>
            </div>

            <ArrowUp
              className="absolute bottom-4 right-4 bg-transparent cursor-pointer p-1 rounded text-[#2B1C25]"
              height={44}
              width={44}
            />
          </button>
        )}
      </div>
    </div>
  );
};
